module.exports = __webpack_public_path__ + "static/media/icon_menu_hamburger.76b0d5e2.svg";